import { Injectable } from "@angular/core";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";

@Injectable({
    providedIn: "root",
})
export class DevicesService {
    private deviceType: "mobile" | "tablet" | "desktop" = "desktop";

    constructor(private breakpointObserver: BreakpointObserver) {
        this.detectDeviceType();
    }

    getDeviceType(): "mobile" | "tablet" | "desktop" {
        return this.deviceType;
    }

    isMobile(): boolean {
        return this.deviceType === "mobile";
    }

    isTablet(): boolean {
        return this.deviceType === "tablet";
    }

    isDesktop(): boolean {
        return this.deviceType === "desktop";
    }

    private detectDeviceType(): void {
        this.breakpointObserver
            .observe([Breakpoints.Handset, Breakpoints.Tablet, Breakpoints.Web])
            .subscribe((result) => {
                if (result.matches) {
                    if (this.breakpointObserver.isMatched(Breakpoints.Handset)) {
                        this.deviceType = "mobile";
                    } else if (this.breakpointObserver.isMatched(Breakpoints.Tablet)) {
                        this.deviceType = "tablet";
                    } else {
                        this.deviceType = "desktop";
                    }
                }
            });
    }
}
